import styled from "styled-components";

export const CellWithLeftPadding = styled.div`
    padding-left: 12px;

    & ~ span {
        display: none;
    }
`;

export const CellWithRightPadding = styled.span<{ withRightPadding: boolean }>`
    ${({ withRightPadding }) => withRightPadding && "padding-right: 12px;"}
`;

export const LastSubColumn = styled.div<{ withRightPadding: boolean }>`
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    ${({ withRightPadding }) => withRightPadding && "padding-right: 12px;"}
`;
